import { InspectorControlsGeneral } from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import Label from '@components/block-label';
import Select from 'react-select';

const {
  i18n: { __ },
  blockEditor: { __experimentalDateFormatPicker: DateFormatPicker },
  coreData: { store: coreStore },
  data: { useSelect, useDispatch },
  components: {
    PanelBody,
    SelectControl,
    ToggleControl,
    TextControl,
    RadioControl,
  },
  blocks: { createBlock },
} = wp;

const InspectorGeneral = ({
  attributes,
  setAttributes,
  showMetaDataFormatInput,
  postSelectIsLoading,
  posts,
  clientId,
  innerBlocks,
  context,
}) => {
  const isDisablePostSelect =
    context['b3rg/postSelection'] && context['b3rg/postSelection'] === 'auto'
      ? true
      : false;

  const {
    blockVisibility,
    selectedPostType,
    selectedPost,
    isBackgroundImage,
    fancyBoxClasses,
    anchorAppearance,
    dateFormat,
    label,
  } = attributes;

  const { replaceInnerBlocks } = useDispatch('core/block-editor');

  const postTypes = useSelect((select) => {
    const { getPostTypes } = select(coreStore);
    const excludedPostTypes = ['attachment'];

    const filteredPostTypes = [];
    getPostTypes({ per_page: -1 })?.forEach((postType) => {
      const { viewable, slug, name } = postType;
      if (viewable && !excludedPostTypes.includes(slug)) {
        filteredPostTypes.push({ value: slug, label: name });
      }
    });
    return filteredPostTypes;
  }, []);

  const onChangePostType = (postType) => {
    setAttributes({
      selectedPostType: postType,
      selectedPost: '',
    });
  };

  const assignSelectedPostValuesToCustomBlock = (
    innerBlocks,
    title,
    clientId,
  ) => {
    const updatedInnerBlocks = [];
    //set post title as heading block content
    innerBlocks.forEach((block) => {
      if (block.innerBlocks.length) {
        const { clientId, innerBlocks } = block;
        updatedInnerBlocks.push(
          assignSelectedPostValuesToCustomBlock(innerBlocks, title, clientId),
        );
      } else if (block.name === 'core/heading') {
        updatedInnerBlocks.push(
          createBlock('core/heading', { ...block.attributes, content: title }),
        );
      } else {
        updatedInnerBlocks.push(block);
      }
    });
    return replaceInnerBlocks(clientId, updatedInnerBlocks);
  };

  const onChangePosts = (newVal) => {
    setAttributes({ selectedPost: newVal });
    assignSelectedPostValuesToCustomBlock(innerBlocks, newVal.label, clientId);
  };

  const onchangeImageAppearance = (isBackgroundImage) => {
    setAttributes({ isBackgroundImage });
  };

  return (
    <InspectorControlsGeneral>
      <Label {...{ label, setAttributes }} />
      <Visibility {...{ blockVisibility, setAttributes }} />
      <PanelBody title={__('Post Settings', 'b3rg')}>
        {!isDisablePostSelect && (
          <>
            <label htmlFor="post-type" className="post-type">
              {__('Post Type', 'b3rg')}
            </label>
            <SelectControl
              options={postTypes}
              value={selectedPostType}
              onChange={onChangePostType}
            />
            <label htmlFor="post-list" className="post-list">
              {__('Posts', 'b3rg')}
            </label>
            <div className="components-base-control">
              <Select
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                placeholder={__('Select a post', 'b3rg')}
                options={posts}
                value={selectedPost}
                isLoading={postSelectIsLoading}
                onChange={onChangePosts}
              />
            </div>
          </>
        )}
        <TextControl
          label="Popup Box class name"
          value={fancyBoxClasses}
          placeholder="Popup Box class name"
          onChange={(fancyBoxClasses) =>
            setAttributes({
              fancyBoxClasses,
            })
          }
        />
        {showMetaDataFormatInput && (
          <DateFormatPicker
            format={dateFormat}
            defaultFormat={'M j, Y'}
            onChange={(dateFormat) => {
              setAttributes({ dateFormat });
            }}
          />
        )}
        <RadioControl
          label={__('Anchor Element Appearance', 'b3rg')}
          options={[
            { label: 'Wrap All', value: 'full' },
            { label: 'Inner Link', value: 'inner' },
          ]}
          selected={anchorAppearance}
          onChange={(anchorAppearance) => {
            setAttributes({ anchorAppearance });
          }}
        />
        <ToggleControl
          label="Set Image As a Background"
          checked={isBackgroundImage}
          onChange={onchangeImageAppearance}
        />
      </PanelBody>
    </InspectorControlsGeneral>
  );
};

export default InspectorGeneral;
